<script>
import ExploreListingPage from '../index.vue'
export default ExploreListingPage
</script>